/**
 * Inserts a value (returned by a callback function) between each element of the input array.
 *
 * @example
 * insertBetween(['a', 'b', 'c'], i => '-') // ['a', '-', 'b', '-', 'c']
 * insertBetween([1, 2, 3], i => i)         // [1, 0, 2, 1, 3]
 */
export const insertBetween = <T, K = T>(
  arr: readonly T[],
  fn: (index: number) => K,
): (T | K)[] => {
  return arr.flatMap((item, index) =>
    index < arr.length - 1 ? [item, fn(index)] : [item],
  );
};
